import { create } from 'zustand';

const useMessageStore = create((set, get) => ({
  // State
  // messages keyed by contextId (channelId or dmId)
  messages: {},
  hasMore: {},
  loading: {},

  // Actions
  setMessages: (contextId, msgs) =>
    set((state) => ({
      messages: { ...state.messages, [contextId]: msgs },
    })),

  prependMessages: (contextId, olderMsgs) =>
    set((state) => {
      const existing = state.messages[contextId] || [];
      // Deduplicate by id
      const existingIds = new Set(existing.map((m) => m.id));
      const unique = olderMsgs.filter((m) => !existingIds.has(m.id));
      return {
        messages: {
          ...state.messages,
          [contextId]: [...unique, ...existing],
        },
      };
    }),

  appendMessage: (contextId, message) =>
    set((state) => {
      const existing = state.messages[contextId] || [];
      // Avoid duplicates
      if (existing.some((m) => m.id === message.id)) {
        return state;
      }
      return {
        messages: {
          ...state.messages,
          [contextId]: [...existing, message],
        },
      };
    }),

  updateMessage: (contextId, messageId, updates) =>
    set((state) => {
      const existing = state.messages[contextId];
      if (!existing) return state;
      return {
        messages: {
          ...state.messages,
          [contextId]: existing.map((m) =>
            m.id === messageId ? { ...m, ...updates } : m,
          ),
        },
      };
    }),

  removeMessage: (contextId, messageId) =>
    set((state) => {
      const existing = state.messages[contextId];
      if (!existing) return state;
      return {
        messages: {
          ...state.messages,
          [contextId]: existing.filter((m) => m.id !== messageId),
        },
      };
    }),

  setLoading: (contextId, isLoading) =>
    set((state) => ({
      loading: { ...state.loading, [contextId]: isLoading },
    })),

  setHasMore: (contextId, value) =>
    set((state) => ({
      hasMore: { ...state.hasMore, [contextId]: value },
    })),

  getMessages: (contextId) => get().messages[contextId] || [],
  isLoading: (contextId) => get().loading[contextId] || false,
  getHasMore: (contextId) => get().hasMore[contextId] ?? true,
}));

export default useMessageStore;
